import { defineStore } from 'pinia';
import MomentApi from '@/api/momentApi'

const momentApi = new MomentApi()

// 朋友圈动态状态
export default defineStore('momentStore', {
	state: () => {
		return {
			moments: [],   // 时间线 List<MomentsVO>
			loading: false
		}
	},
	actions: {
		// 加载本人及好友的动态时间线
		async loadTimeline(page, size) {
			this.loading = true
			try {
				this.moments = await momentApi.timeline(page, size)
			} finally {
				this.loading = false
			}
		},
		// 发布动态,成功后刷新时间线(最新置顶)
		async publish(content, images) {
			const id = await momentApi.publish(content, images)
			await this.loadTimeline(1, 20)
			return id
		},
		// 删除动态,本地同步移除
		async remove(id) {
			await momentApi.remove(id)
			this.moments = this.moments.filter(m => m.id !== id)
		}
	}
})
